import { KeyboardEvent } from 'react';
import { TextField, TextFieldProps } from '@rossum/ui/material';

type CommentTextareaProps = TextFieldProps & { onSubmit: () => void };

export const CommentTextarea = ({
  onSubmit,
  ...props
}: CommentTextareaProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevents adding a newline character
      onSubmit();
    }
  };

  return (
    <TextField {...props} size="small" onKeyDown={handleKeyDown} multiline />
  );
};
